import {useRef, useEffect, useContext} from 'react';
import {SoundContext} from '../components/SoundContext';

const usePlaySound = (audioPath)=>{
    const audioRef = useRef(null);
    const {isSoundOn} = useContext(SoundContext);

    useEffect(()=>{
        if(!audioPath.current){
            audioRef.current = new Audio(audioPath);
            audioRef.current.load();

            return ()=>{
                if(audioRef.current){//clean up after done using audio
                    audioRef.current.pause();
                    audioRef.current = null;
                }
            }

        }
    },[audioPath]);

    const playSound = ()=>{
        if(isSoundOn && audioRef.current){
            const audio = new Audio(audioPath);
            audio.play().catch(e=>console.error(`Sound playback error: `,e));
            //resetting the audio doesn't seem to work well
            // audioRef.current.currentTime = 0;
            // audioRef.current.play().catch(e=>console.error(`Sound playback error for ${audioPath}:`, e));
        }
    };

    return playSound;
};

export default usePlaySound